import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid } from "@mui/material";

import Loader from "../../../../components/Loader";
import TextFieldInput from "../../../../components/TextFieldInput";
import ReviewInput from "../../../../components/ReviewInput";
import UploadPopup from "../../../../shared-components/upload-popup/UploadPopup";
import CommonButton from "../../../../shared-components/common-button/CommonButton";

import {
  getApplicantDetails,
  setActiveStep,
  setReviewActiveStep,
} from "../../new-booking-form.slice";
import { useParams } from "react-router-dom";
import { BOOKING_AS } from "../../../../config/constant";

const ReviewCompanyDetails = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { oppId } = useParams();
  
  const [openPopup, setOpenPopup] = useState(false);
  const [fieldName, setFieldName] = useState("");

  const { isLoading, applicantData, activeStep, entity, reviewActiveStep } = useSelector((state) => state?.newBookingForm);

  useEffect(() => {
      dispatch(getApplicantDetails(`/${oppId}`));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const companyDetails = applicantData?.companyDetails || {};
  const documents = companyDetails?.documents || {};

  const handleView = (name) => {
    setFieldName(name);
    setOpenPopup(true);
  };

  const handlePrevious = () => {
    dispatch(setActiveStep(activeStep - 1));
  };

  const handleSaveForm = () => {
    dispatch(setReviewActiveStep(reviewActiveStep + 1));
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div>
        <Box sx={{ border: "1px dashed #DADADA", borderRadius: "8px", p: 2 }}>
          {/* --- Basic Details --- */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextFieldInput
                field={{
                  label: t("companyDetails.labels.companyName", { entity }),
                  readonly: true,
                  value: companyDetails.companyName || "",
                }}
              />
            </Grid>
          </Grid>

          {/* --- Documents --- */}
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("companyDocument.labels.gstCertificate")}
                name="gstCertificate"
                onView={handleView}
                disabled={!documents?.gstCertificate?.length}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("reviewCompanyDetails.labels.panCard")}
                name="pan"
                onView={handleView}
                disabled={!documents?.pan?.length}
              />
            </Grid>
                 {applicantData?.bookingAs === BOOKING_AS.PARTNERSHIP_FIRM ? (
                      <>
                                  <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("companyDocument.labels.partnershipDeed")}
                name="partnershipDeed"
                onView={handleView}
                disabled={!documents?.partnershipDeed?.length}
              />
            </Grid>
                   <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("companyDocument.labels.partnersResolution")}
                name="partnersResolutionPurchase"
                onView={handleView}
                disabled={!documents?.partnersResolutionPurchase?.length}
              />
            </Grid>

                      </>
                    ) : (<>
            <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("companyDocument.labels.incorporationCertificate")}
                name="incorporationCertificate"
                onView={handleView}
                disabled={!documents?.incorporationCertificate?.length}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("companyDocument.labels.memorandumofAssociation")}
                name="memorandumOfAssociation"
                onView={handleView}
                disabled={!documents?.memorandumOfAssociation?.length}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("companyDocument.labels.articlesofAssociation")}
                name="articlesOfAssociation"
                onView={handleView}
                disabled={!documents?.articlesOfAssociation?.length}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ReviewInput
                text={t("companyDocument.labels.boardResolution")}
                name="boardResolutionPurchase"
                onView={handleView}
                disabled={!documents?.boardResolutionPurchase?.length}
              />
            </Grid></>)}
          </Grid>
        </Box>

        {/* Popup for viewing docs */}
        {openPopup && (
          <UploadPopup
            heading="View"
            totalImages={1}
            closePopup={() => setOpenPopup(false)}
            uploadedImage={documents?.[fieldName] || []}
            fieldName={fieldName}
            hidePhysicalCopyOption
            dynamicSize={1}
            hideCameraOption={false}
            showDeleteIcon={false}
          />
        )}

        {/* Stepper controls */}
        <CommonButton
          handlePrevious={handlePrevious}
          handleNext={handleSaveForm}
          saveForLater={false}
        />
      </div>
    </>
  );
};

export default ReviewCompanyDetails;
